interface IconSpec {
  rel: string
  sizes?: string
}

const specs: IconSpec[] = [
  { rel: 'icon' },
  { rel: 'shortcut icon' },
  { rel: 'apple-touch-icon', sizes: '180x180' },
]

/**
 * Sætter fanebladets ikon og titel.
 * Fjerner eksisterende ikoner (fx standard-globussen), så kun logoet vises
 * i browserfaner på både computer og mobil.
 */
export function applyBrandIcon(iconUrl: string, title: string): void {
  if (typeof document === 'undefined') return

  document.title = title

  document
    .querySelectorAll("link[rel~='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']")
    .forEach((node) => node.parentNode?.removeChild(node))

  specs.forEach((spec) => {
    const link = document.createElement('link')
    link.rel = spec.rel
    link.type = 'image/png'
    link.href = iconUrl
    if (spec.sizes) link.sizes = spec.sizes
    document.head.appendChild(link)
  })
}
